module.exports = __webpack_public_path__ + "static/img/Bachelor_010321.42ba4ed.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Bachelor_010321.jpg
// module id = 148
// module chunks = 0